import React, { useEffect } from "react";
import { Stack } from '@mui/material';
import { toast } from "sonner";
import { useAppSelector } from '../../redux/hooks';
import { useProfileForm } from '../../hooks/useProfileForm';
import ProfileInfoCard from "../../components/profile-info-card/ProfileInfoCard";
import { ProfilePageLayout } from "../../components/profile-page-layout/ProfilePageLayout";

const HrProfilePage: React.FC = () => {
    const { user, loading, error } = useAppSelector((state) => state.currentUser);

    const {
        workdayId,
        userName,
        setUserName,
        nameError,
        site,
        userEmail,
        email,
        setEmail,
        phone,
        handlePhoneChange,
        hasChanges,
        updating,
        handleSaveChanges,
    } = useProfileForm({ isHROrManager: false, displayUser: user });

    useEffect(() => {
        if (error) {
            toast.error(`Failed to load profile: ${error}`);
        }
    }, [error]);

    return (
        <ProfilePageLayout
            title="My Profile"
            subtitle="Manage your personal information and preferences"
            loading={loading && !user}
        >
            <Stack direction="row" justifyContent="flex-start" sx={{ px: { xs: '18px', md: '20px' } }}>
                <ProfileInfoCard
                    workdayId={workdayId}
                    userName={userName}
                    setUserName={setUserName}
                    nameError={nameError}
                    userEmail={userEmail}
                    email={email}
                    setEmail={setEmail}
                    phone={phone}
                    onPhoneChange={handlePhoneChange}
                    site={site}
                    isReadOnly={false}
                    hasChanges={hasChanges}
                    updating={updating}
                    onSave={handleSaveChanges}
                    showSaveButton={true}
                    sx={{
                        maxWidth: '50%',
                        width: '100%',
                        '@media (max-width: 1024px)': { maxWidth: '85%' },
                        '@media (max-width: 768px)': { maxWidth: '100%' },
                    }}
                />
            </Stack>
        </ProfilePageLayout>
    );
};

export default HrProfilePage;